import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import experiences from '../lib/experience.ts';

const Experiences = () => {
  return (
    <div className="relative">
      <div className="absolute left-4 md:left-6 top-2 bottom-2 w-px bg-gradient-to-b from-orange-400 via-orange-400/40 to-transparent" />

      <div className="space-y-10">
        {experiences.map((experience, index) => (
          <div key={index} className="relative pl-12 md:pl-16">
            <div className="absolute left-0 top-0 w-8 h-8 md:w-12 md:h-12 rounded-full bg-gray-900 border-2 border-orange-400 flex items-center justify-center text-orange-400 shadow-[0_0_12px_rgba(251,146,60,0.35)]">
              <FontAwesomeIcon icon={faBriefcase} className="text-xs md:text-base" />
            </div>

            <div className="bg-gray-800/60 backdrop-blur-sm p-6 rounded-xl border border-gray-700 shadow-lg hover:border-orange-400/60 hover:-translate-y-1 hover:shadow-orange-400/10 transition-all duration-300">
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-2 mb-2">
                <h3 className="text-2xl font-bold text-white">{experience.company}</h3>
                <span className="inline-block w-fit text-xs text-gray-300 bg-gray-900 border border-gray-700 rounded-full px-3 py-1">
                  {experience.period}
                </span>
              </div>
              <p className="text-orange-400 font-semibold mb-3">{experience.role}</p>
              <p className="text-gray-300 text-sm mb-4">{experience.description}</p>
              <ul className="space-y-2 text-gray-300 text-sm mb-4">
                {experience.highlights.map((highlight, idx) => (
                  <li key={idx} className="flex items-start">
                    <span className="text-orange-400 mr-3">•</span>
                    <span>{highlight}</span>
                  </li>
                ))}
              </ul>
              <div className="flex flex-wrap gap-1.5">
                {experience.tech.map((tech, idx) => (
                  <span
                    key={idx}
                    className="inline-flex items-center rounded-md border px-2.5 py-1 text-xs
                      border-transparent bg-gray-700 text-primary-foreground shadow hover:bg-primary/80 transition-colors"
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Experiences;
